<template lang="pug">
.ExcelObjects(v-if='objects')
  .ExcelObjects-header.Menu
    .Menu-left Количество записей: {{ objects.count }}
    .Menu-right(v-if='!layerSettings.is_integration')
      .Menu-item
        | Выбрано:
        b {{ Object.keys(selected).length }}
      .Menu-item
        button.Btn.Btn--transparent.Btn--light.BtnIcon.TextRed(
          v-if='permissions.canDeleteAggregateInfoLayer',
          @click='removeSelectedObjects'
        ) Удалить выбранные
      .Menu-delimiter
      .Menu-item.Menu-link
        button.Menu-add.Btn.Btn--transparent.Btn--light.BtnIcon(
          v-if='permissions.canCreateAggregateInfoLayer',
          @click='addObject'
        )
          i.Icon.IconPlus
          | Добавить запись
  .ExcelObjects-table(:class='{ "ExcelObjects-table--pagination": true }')
    table
      thead
        tr
          th.ExcelObjects-cell--sticky(v-if='!layerSettings.is_integration')
          th
          th(v-for='header in headers') {{ header.rus_name || header.id }}
          th.ExcelObjects-cell--sticky(v-if='!layerSettings.is_integration')
      tbody
        tr(
          v-for='object in objects.result',
          :key='object.id'
        )
          th.ExcelObjects-cell--sticky(v-if='!layerSettings.is_integration')
            label
              input(
                type='checkbox',
                @change='toggleSelected(object.id)',
                :checked='selected[object.id]'
              )
              span
          th
            i.ExcelObjects-map-marker.IconMapMarker(
              :class='{ "ExcelObjects-map-marker--active": checkObjectCoordinates(object) }',
              @mouseover.stop='mapMarkerMouseOver(object)',
              @mouseout.stop='helperText = null'
            )
          td(v-for='header in headers') {{ object[header.name_in_table] }}
          th.ExcelObjects-cell--sticky(v-if='!layerSettings.is_integration')
            .ExcelObjects-actions
              button.Btn.BtnIcon(
                v-if='permissions.canEditAggregateInfoLayer',
                @click='editObject(object)',
                @mouseover.stop='helperText = "Редактировать объект"',
                @mouseout.stop='helperText = null'
              )
                i.Icon.IconPanelEditObject
              button.Btn.BtnIcon(
                v-if='permissions.canDeleteAggregateInfoLayer',
                @click='removeObject(object.id)',
                @mouseover.stop='helperText = "Удалить объект"',
                @mouseout.stop='helperText = null'
              )
                i.Icon.IconRemove
  pagination.ExcelObjects-pagination(
    :limit='+objects.limit',
    :offset='+objects.offset',
    :count='+objects.count',
    @page='goToPage'
  )
  .ModalFooter.ExcelObjects-footer
    .ModalFooter-left
      router-link.Btn.Btn--light.Btn--red(
        tag='button',
        :to='{ name: "excel-layer-list" }'
      ) Вернуться к списку слоев
</template>

<script>
import Pagination from '@/components/Pagination.vue'
import ExcelLayerObject from '@/components/popups/ExcelLayerObject'
import helpertext from '@/mixins/helpertext'

export default {
  name: 'excel-object-list',

  mixins: [helpertext],

  components: {
    Pagination
  },

  data() {
    return {
      selected: {},
      limit: 10
    }
  },

  computed: {
    permissions() {
      return this.$store.getters.permissions
    },
    routeLayerId() {
      return this.$route.params.layerId
    },
    objects() {
      return this.$store.getters.excelLayerObjectList
    },
    layerSettings() {
      return this.$store.getters.excelLayerSettings || {}
    },
    headers() {
      return this.layerSettings.headers || []
    }
  },

  watch: {
    '$route.query.offset'() {
      this.getLayers()
    }
  },

  mounted() {
    this.getLayers()
  },

  methods: {
    toggleSelected(id) {
      if (this.selected[id]) {
        delete this.selected[id]
      } else {
        this.selected[id] = true
      }
      this.selected = { ...this.selected }
    },
    goToPage(offset) {
      this.$router.push({ query: { offset } })
    },
    getLayers() {
      const offset = this.$route.query.offset || 0
      this.$store.dispatch('getExcelLayerObjectList', {
        id: this.routeLayerId,
        offset: offset,
        limit: this.limit
      })
    },
    removeSelectedObjects() {
      //Если запущен процесс удаления выбранных, то ничего не делаем
      if (this.isDeletingSelected) {
        return
      }

      this.$ui.toast.hide()
      if (Object.keys(this.selected).length === 0) {
        this.$ui.toast.show({ text: 'Не выбрано ни одной записи', time: '5000', type: 'error' })
        return
      }

      this.isDeletingSelected = true
      this.$ui.toast.show({ text: 'Удаление выбранных объектов', type: 'progress', time: 60000 })
      this.$store
        .dispatch('deleteExcelObject', {
          id: this.routeLayerId,
          obj_ids: Object.keys(this.selected).join(',')
        })
        .then((v) => {
          this.$ui.toast.show({ text: 'Записи удалены', time: '5000', type: 'success' })
          this.getLayers()
          this.selected = {}
        })
        .catch((e) => {
          this.$ui.toast.show({ text: 'Ошибка удаления записи', time: '5000', type: 'error' })
        })
        .finally(() => {
          this.isDeletingSelected = false
        })
    },

    addObject() {
      this.$ui.popup
        .show({
          component: ExcelLayerObject,
          params: {
            width: '734px',
            headers: this.headers,
            layerId: this.routeLayerId + '',
            title: 'Добавить запись'
          }
        })
        .then((v) => {
          this.getLayers()
        })
    },
    editObject(item) {
      this.$ui.popup
        .show({
          component: ExcelLayerObject,
          params: {
            width: '734px',
            headers: this.headers,
            item: item,
            layerId: this.routeLayerId + '',
            title: 'Редактировать запись'
          }
        })
        .then((v) => {
          this.getLayers()
        })
    },

    removeObject(id) {
      //Создание карты удаляемых объектов
      if (!this.idInProcessMap) {
        this.idInProcessMap = {}
      }

      //Если объект в процессе удаления, то не вызываем запрос повторно
      if (this.idInProcessMap[id]) {
        return
      }

      this.idInProcessMap[id] = true
      this.$ui.toast.show({ text: 'Удаление', type: 'progress', time: 60000 })
      this.$store
        .dispatch('deleteExcelObject', {
          id: this.routeLayerId,
          obj_ids: id
        })
        .then((v) => {
          this.$ui.toast.show({ text: 'Запись удалена', time: '5000', type: 'success' })
          this.getLayers()
        })
        .catch((e) => {
          this.$ui.toast.show({ text: 'Ошибка удаления записи', time: '5000', type: 'error' })
        })
        .finally(() => {
          this.idInProcessMap[id] = false
        })
    },

    checkObjectCoordinates(layerObject) {
      const headerIds = this.layerSettings.headers.map((headerItem) => {
        return headerItem.name_in_table
      })

      const isLinear = headerIds.includes('sourcepoint') && headerIds.includes('sinkpoint')
      const isPoint = headerIds.includes('sourcepoint')

      return (isLinear && layerObject.sourcepoint && layerObject.sinkpoint) || (isPoint && layerObject.sourcepoint)
    },

    mapMarkerMouseOver(layerObject) {
      const hasCoordinates = this.checkObjectCoordinates(layerObject)
      if (hasCoordinates) {
        this.helperText = 'У объекта есть координаты'
      } else {
        this.helperText = 'Координаты объекта не заданы'
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import '~base';

#app .ExcelObjects {
  --menuColor: #{$grey8};
  --tableBg: #{$grey7};
  --menuLinkColor: #{$blue};
  --tableThColor: #{$grey2};
}

#app[data-theme='dark'] .ExcelObjects {
  --menuColor: #{$grey1};
  --tableBg: #{$black3};
  --menuLinkColor: #{$blue};
  --tableThColor: #{$grey1};
}

.Menu {
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 35px;
  padding: 0 15px;
  color: var(--menuColor);
  font-size: 12px;
  border-bottom: 1px solid var(--delimiter);

  &-right {
    display: flex;
    align-items: center;
  }

  &-add {
    color: var(--menuLinkColor);
  }

  &-item {
    margin-left: 15px;

    b {
      margin-left: 5px;
    }

    button {
      display: flex;
      align-items: center;

      .Icon {
        margin-right: 10px;
        font-size: 14px;
      }
    }
  }

  &-delimiter {
    width: 1px;
    height: 24px;
    margin-left: 15px;
    background: var(--delimiter);
  }
}
.ExcelObjects {
  color: var(--basicText);

  &-header,
  &-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 48px;
  }

  &-pagination {
    height: 84px;
    padding: 26px 15px;
  }

  &-actions {
    display: flex;

    .Btn {
      margin: 0 7px;
      color: var(--secondaryText);

      &:hover {
        .Icon {
          color: var(--accentColor);
        }
      }
    }

    .Icon {
      font-size: 16px;
    }
  }

  &-table {
    overflow-y: auto;
    height: calc(100vh - 186px); // header + tabs + objects header + footer

    &--pagination {
      height: calc(100vh - 270px); // header + tabs + objects header + footer + pagination
    }

    thead th {
      position: sticky;
      color: var(--tableThColor);
      font-size: 12px;
      line-height: 14px;
      top: 0;
      z-index: 1;

      &:first-child {
        z-index: 2;
      }
    }

    tbody {
      font-family: 'Roboto Mono';
      font-size: 12px;
      font-weight: 500;
      line-height: 16px;
    }

    tbody th.ExcelObjects-cell--sticky:first-child,
    thead th.ExcelObjects-cell--sticky:first-child {
      position: sticky;
      left: 0;
    }

    tbody th.ExcelObjects-cell--sticky:last-child,
    thead th.ExcelObjects-cell--sticky:last-child {
      position: sticky;
      right: 0;
    }

    table {
      border-collapse: collapse;
      width: 100%;
    }

    th,
    td {
      padding: 5px 10px;
      background: var(--tableBg);
      font-weight: 400;
      box-shadow: inset 1px -1px var(--appBg), inset 1px 1px var(--appBg), inset -1px -1px var(--appBg), inset -1px 1px var(--appBg);

      label {
        vertical-align: 3px;
      }
    }
  }

  &-map-marker {
    font-size: 16px;
    color: var(--secondaryText);

    &--active {
      color: var(--accentColor);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/excel-layers/ExcelObjectList.vue